import { render, staticRenderFns } from "./SettingsAlertRecipientSelect.vue?vue&type=template&id=7d1e134a"
import script from "./SettingsAlertRecipientSelect.vue?vue&type=script&lang=ts"
export * from "./SettingsAlertRecipientSelect.vue?vue&type=script&lang=ts"
import style0 from "./SettingsAlertRecipientSelect.vue?vue&type=style&index=0&id=7d1e134a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports